import * as React from 'react';
import { useContext, useState } from 'react';
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  IconButton,
  TextField,
  Select,
  MenuItem, InputLabel
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { styled } from '@mui/material/styles';
import { CreativeTagState, PlayerState } from '../types/playlist';
import axios from 'axios';
import { getApiBaseUrl } from '../../utils/env';
import { OrganisationContext } from '../../App';
import { useParams } from 'react-router-dom';
import { creativeUrl, dsps, dspTag } from '../utils/dspTag';

const CloseBtnRoot = styled('div')`
    position: absolute;
    right: 10px;
    top: 10px;
`;

const Root = styled('div')`
    padding: 20px 40px 0;
    position: relative;
`;

const TitleDialog = styled(DialogTitle)`
    position: relative;
    padding-top: 0;

    &:after {
        content: ' ';
        background-color: #ccc;
        width: calc(100% + 80px);
        height: 1px;
        position: absolute;
        left: -40px;
        bottom: 10px;
    }
`;

const Title = styled('div')`
    font-weight: bold;
    margin: 24px 0 0 0;
    color: black;
`;

type AddPlaylistCreativeTagDialogProps = {
  open: boolean;
  handleClose: () => void;
  tag: CreativeTagState;
  creative: PlayerState
};

export const AddPlaylistCreativeTagDialog = ({
  open,
  handleClose,
  tag,
  creative,
}: AddPlaylistCreativeTagDialogProps) => {
  const { selectedOrganisation } = useContext(OrganisationContext);
  const { playlist } = useParams();
  const [name, setName] = useState<string>(tag.name);
  const [tagType, setTagType] = useState<string>(tag.dsp_name ||'');

  const onSubmit = async (e) => {
    e.preventDefault();

    const url = creativeUrl(creative, selectedOrganisation as string);
    const creativeTag = dspTag(tagType, url, creative.click_thru_url);

    if (tag.id) {
      await axios.patch(`${getApiBaseUrl()}/playlist-tag/${selectedOrganisation}/${playlist}/${tag.id}`, {
        playlist_player_id: creative.id,
        name,
        dsp_name: tagType,
        tag: creativeTag,
        id: tag.id,
      });
    } else {
      await axios.post(`${getApiBaseUrl()}/playlist-tag/${selectedOrganisation}/${playlist}`, {
        playlist_player_id: creative.id,
        name,
        dsp_name: tagType,
        tag: creativeTag
      });

    }

    handleClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth={true} maxWidth={'sm'}>
      <Root>
        <CloseBtnRoot>
          <IconButton onClick={handleClose}>
            <CloseIcon/>
          </IconButton>
        </CloseBtnRoot>
        <TitleDialog>
          <Title>{`${tag.name ? 'Edit' : 'Add'} tag`}</Title>
        </TitleDialog>
        <DialogContent>
          <form onSubmit={onSubmit}>
            <Grid container spacing={2} style={{ marginTop: 0 }}>
              <Grid item xs={12}>
                <FormControl fullWidth>
                  <TextField
                    id="name"
                    required
                    label="Tag name"
                    variant="outlined"
                    type={'text'}
                    autoFocus
                    onChange={({ target: { value }}) => setName(value)}
                    value={name}
                  />
                </FormControl>
                <FormControl fullWidth sx={{ mt: 2 }}>
                  <InputLabel id="dspLabel" required>DSP</InputLabel>
                  <Select
                    id="dsp"
                    labelId="dspLabel"
                    label="DSP"
                    required
                    value={tagType}
                    onChange={(e) => setTagType(e.target.value)}
                    displayEmpty
                    variant="outlined"
                  >
                    { dsps.map((dsp) => (<MenuItem value={dsp.value}>{dsp.value}</MenuItem>)) }
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <Grid container justifyContent={'flex-end'}>
                  <Button type={'submit'} color="primary" variant="contained">
                    Save
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </form>
        </DialogContent>
      </Root>
    </Dialog>
  );
};
